import React from 'react';
import './verticalBarChart.css'
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
} from 'chart.js';
import {Bar} from 'react-chartjs-2';
import {css} from "@emotion/css";


const VerticalBarChart = () => {
    ChartJS.register(
        CategoryScale,
        LinearScale,
        BarElement,
        Title,
        Tooltip,
        Legend
    );
    const options = {
        responsive: true,
        plugins: {
            legend: {
                position: 'top',
                color: '#895',
                fontFamily: '',
                fontsize: '24px',
            },
            title: {
                display: true,
                text: 'نمودار میله ای ساده',
            },
        },
    };
    const labels = ['شنبه', 'February', 'March', 'April', 'May', 'June', 'July'];
    const data = {
        labels,
        datasets: [
            {
                label: 'گزارش اول',
                data: [5, 10, 15, 20],
                backgroundColor: 'rgba(255, 99, 132, 0.5)',
            },
            {
                label: 'گزارش دوم',
                data: [25, 30, 35, 40],
                backgroundColor: 'rgba(53, 162, 235, 0.5)',

            },
        ],
    };
    return (
        <div>
            <Bar id="vertical-bar-chart" options={options} data={data}/>

        </div>
    )
}
export default VerticalBarChart;

